// Generated by ReScript, PLEASE EDIT WITH CARE

import * as T from "common/src/T.bs.js";
import * as Link from "../Link.bs.js";
import * as React from "react";
import * as Global from "common/src/Global.bs.js";
import * as Tooltip from "common/src/components/Tooltip.bs.js";
import * as UnitImage from "common/src/tft-static/UnitImage.bs.js";
import * as UnitName0 from "common/src/tft-static/UnitName0.bs.js";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as StatsTable2 from "../components/StatsTable2.bs.js";
import * as UnitTooltip from "common/src/tft-static/UnitTooltip.bs.js";

var cols = [
  StatsTable2.col(false, undefined, (function (param, param$1) {
          return param$1.t("Unit");
        }), undefined, (function (v, param, param$1) {
          return React.createElement(Link.make, {
                      route: {
                        TAG: /* Stats */0,
                        _0: {
                          TAG: /* Unit */4,
                          unit: v.id,
                          starLevel: undefined,
                          aperture: param$1.aperture
                        }
                      },
                      children: React.createElement("div", {
                            className: "flex items-center text-sm"
                          }, React.createElement("div", {
                                className: "flex-shrink-0"
                              }, React.createElement(UnitTooltip.make, {
                                    unit: v.id,
                                    children: React.createElement(UnitImage.make, {
                                          unitId: v.id,
                                          size: 28,
                                          showName: false
                                        })
                                  })), React.createElement("div", {
                                className: "pl-[6px] font-roboto font-normal truncate"
                              }, React.createElement(UnitName0.make, {
                                    unit: v.id
                                  })))
                    });
        }), undefined, undefined, undefined, (function (v, param, param$1) {
          return param$1.unitsT(v.id);
        }), undefined, 180, undefined, undefined),
  StatsTable2.col(undefined, true, (function (param, param$1) {
          return param$1.t("Play rate");
        }), undefined, (function (v, totCount, param) {
          return Global.formatPct(undefined, Global.f(v.count) / Global.f(totCount)) + "%";
        }), undefined, (function (v, param, param$1) {
          return T.humanReadableCount(v.count) + " games";
        }), undefined, (function (v, param, param$1) {
          return v.count;
        }), undefined, 106, undefined, undefined),
  StatsTable2.col(false, true, (function (param, param$1) {
          return param$1.t("Place");
        }), undefined, (function (v, param, param$1) {
          return Global.toFixed(undefined, v.place);
        }), undefined, undefined, undefined, (function (v, param, param$1) {
          return v.place;
        }), undefined, 80, undefined, undefined),
  StatsTable2.col(false, true, (function (param, param$1) {
          return param$1.t("Delta");
        }), undefined, (function (v, param, param$1) {
          return Global.toFixedSign(undefined, v.delta2);
        }), undefined, undefined, Caml_option.some(Tooltip.delta), (function (v, param, param$1) {
          return v.delta2;
        }), undefined, 80, undefined, undefined),
  StatsTable2.col(false, true, (function (param, param$1) {
          return param$1.t("Rel. Delta");
        }), undefined, (function (v, param, param$1) {
          return Global.toFixedSign(undefined, v.delta);
        }), undefined, undefined, Caml_option.some(Tooltip.relDelta), (function (v, param, param$1) {
          return v.delta;
        }), undefined, 90, undefined, undefined),
  StatsTable2.col(undefined, true, (function (param, param$1) {
          return param$1.t("Top 4") + " %";
        }), undefined, (function (v, param, param$1) {
          return Global.formatPct3(v.top4);
        }), undefined, undefined, undefined, (function (v, param, param$1) {
          return v.top4;
        }), undefined, 96, undefined, undefined),
  StatsTable2.col(undefined, true, (function (param, param$1) {
          return param$1.t("Win") + " %";
        }), undefined, (function (v, param, param$1) {
          return Global.formatPct3(v.won);
        }), undefined, undefined, undefined, (function (v, param, param$1) {
          return v.won;
        }), undefined, 80, undefined, undefined)
];

function UnitSynergiesTable(Props) {
  var units = Props.units;
  var totCount = Props.totCount;
  var inContext = Props.inContext;
  var scrollRef = Props.scrollRef;
  var data = React.useMemo((function () {
          return Belt_Array.keep(units, (function (v) {
                        if (v.count >= 100) {
                          return v.count >= (totCount / 1000 | 0);
                        } else {
                          return false;
                        }
                      }));
        }), [
        units,
        totCount
      ]);
  var keyFn = React.useCallback((function (v) {
          return v.id;
        }), []);
  var tmp = {
    cols: cols,
    data: data,
    context: totCount,
    keyFn: keyFn,
    stickyColCount: 1,
    defaultSortIdx: 1
  };
  var tmp$1 = inContext ? "t52" : undefined;
  if (tmp$1 !== undefined) {
    tmp.top = Caml_option.valFromOption(tmp$1);
  }
  var tmp$2 = Belt_Option.map(scrollRef, (function (el) {
          return [
                  el,
                  200
                ];
        }));
  if (tmp$2 !== undefined) {
    tmp.scrollEl = Caml_option.valFromOption(tmp$2);
  }
  return React.createElement(StatsTable2.make, tmp);
}

var make = UnitSynergiesTable;

export {
  cols ,
  make ,
  
}
/* cols Not a pure module */
